function facebookConnect(form) {
	function handleResponse(response) {
		if (response.authResponse) {
			form.submit();
		}
	}
	FB.login(handleResponse, { scope: form.dataset.perms });
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	document
		.querySelector(".login-box-facebook-button a")
		.addEventListener("click", function (event) {
			event.preventDefault();
			facebookConnect(this.closest("form"));
			return false;
		});
});
